import { USER_SIGNED_OUT } from 'redux-oidc'
import { getPersisted, persist } from 'utils/persistor'
import { getComponentKey } from 'utils/getComponentKey'
import { constants } from 'consts'

export const initialState = {
  ...getPersisted(constants.LAYOUT_KEY, { toggled: true }),
  layoutKey: getComponentKey(),
  themeKey: getComponentKey(),
  overlayMessage: null,
  redirectToLogin: false
}

export const actionTypePrefix = 'layout'
export const actionTypes = {
  toggle: `${actionTypePrefix}/TOGGLE`,
  change: `${actionTypePrefix}/CHANGE`,
  showOverlay: `${actionTypePrefix}/SHOW_OVERLAY`
}

export const actionCreators = {
  toggleMenu: () => (dispatch) => {
    dispatch({ type: actionTypes.toggle })
  },
  changeTheme: (themeId) => ({
    type: actionTypes.change,
    payload: themeId
  }),
  showOverlay: ({ loading, overlayMessage }) => ({
    type: actionTypes.showOverlay,
    payload: { loading, overlayMessage }
  })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.toggle: {
      const newState = { ...state, toggled: !state.toggled }
      persist(constants.LAYOUT_KEY, newState)
      return newState
    }
    case actionTypes.change: { 
      if (action.payload) {
        const newState = { ...state, themeKey: getComponentKey() }
        persist(constants.THEME_KEY, action.payload)
        return newState
      }
      return state;
    }
    case actionTypes.showOverlay: return { ...state, ...action.payload }
    case USER_SIGNED_OUT: return { ...state, redirectToLogin: true }

    default: return state
  }
}
